/**
 * @prettier
 */
/// <reference types="knockout">

/**
 * 
 * @param {Function} findLocation 
 * @param {Function} findQueue 
 * @param {Function} onClose 
 */
function EditAppointmentViewModel(findLocation, findQueue, messageService, onClose) {
  this.isVisible = ko.observable(false);

  /**
   * @type {KnockoutObservable<AppointmentModel>}
   */
  this.appointment = ko.observable({});

  this.fields = {
    /**
     * @type {KnockoutComputed<String>}
     */
    status: ko.observable(""),

    /**
     * @type {KnockoutComputed<String>}
     */
    notes: ko.observable(""),
  };

  this.status = ko.observable("foo");

  this.readonlyFields = {
    /**
     * @method confirmationCode
     * @type {KnockoutComputed<String>}
     */
    confirmationCode: ko.computed({
      deferEvaluation: true,
      owner: this,
      read: function () {
        var appointment = this.appointment();
        return appointment.confirmationCode ? appointment.confirmationCode : "";
      },
    }),

    
    /**
     * @type {KnockoutComputed<String>}
     * @method phone
     */
    phone: ko.computed({
      deferEvaluation: true,
      owner: this,
      read: function () {
        var appointment = this.appointment();
        return appointment.phoneDisplay ? appointment.phoneDisplay() : "";
      },
    }),


    /**
     * @type {KnockoutComputed<String>}
     * @method locationName
     */
    locationName: ko.deferredComputed(function () {
      var appointment = this.appointment();
      
      if (appointment.locationId) {
        var location = findLocation(appointment.locationId) 
        return location.name;
      }

      return "";
    }, this),

    /**
     * @type {KnockoutComputed<String>}
     * @method queueDescription
     */
    queueDescription: ko.deferredComputed(function () {
      var appointment = this.appointment();
      
      if (appointment.queueId) {
        var queue = findQueue(appointment.queueId) 
        return queue.description;

      }

      return "";
    }, this),

    /**
     * @type {KnockoutComputed<String>}
     * @method name
     */
    name: ko.deferredComputed(function () {
      var appointment = this.appointment();
      return appointment.name ? appointment.name : "";
    }, this),

    /**
     * @type {KnockoutComputed<String>}
     * @method email
     */
    email: ko.deferredComputed(function () {
      var appointment = this.appointment();
      return appointment.email ? appointment.email : "";
    }, this),

    /**
     * @type {KnockoutComputed<String>}
     * @method resourceName
     */
    resourceNames: ko.deferredComputed(function () {
      var appointment = this.appointment();
      // `resourceName` is a comma-separated list of Resource names
      return appointment.resourceName ? appointment.resourceName : "";
    }, this),

    /**
     * @type {KnockoutComputed<String>}
     * @method transactionTypeDescription
     */
    transactionTypeDescription: ko.deferredComputed(function () {
      var appointment = this.appointment();
      return appointment.transactionType && appointment.transactionType.description
        ? appointment.transactionType.description
        : "";
    }, this),

    /**
     * @type {KnockoutComputed<String>}
     * @method languagePreference
     */
    languagePreference: ko.deferredComputed(function () {
      var appointment = this.appointment();
      return appointment.languagePref ? messageService.languageName(appointment.languagePref) : "";
    }, this),


    /**
     * @type {KnockoutComputed<String>}
     * @method customProps
     */
    customProps: ko.deferredComputed(function () {
      var appointment = this.appointment();
      return appointment.rawCustomProps ? appointment.rawCustomProps : [];
    }, this),

  };

  this.onCloseHandler = onClose;
}

/**
 * Toggle the visibility to true
 */
EditAppointmentViewModel.prototype.show = function (appointment) {
  // console.log(appointment);

  if (appointment) {
    this.appointment(appointment);
    
    if (appointment.notes) {
      this.fields.notes(appointment.notes);
    }

    if (appointment.status) {
      this.fields.status(appointment.status())
    }
  }

  this.isVisible(true);
};

/**
 * Toggle the visibility to false
 */
EditAppointmentViewModel.prototype.hide = function () {
  this.isVisible(false);
};

EditAppointmentViewModel.prototype.handleClose = function (data, event) {
  this.appointment(null);
  this.hide();

  if (this.onCloseHandler instanceof Function) {
    this.onCloseHandler();
  }
};

if (typeof exports !== "undefined") {
  exports.EditAppointmentViewModel = EditAppointmentViewModel;
}
